module.exports = __webpack_public_path__ + "static/img/flypig.ce74da4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/aboutUs/flypig.svg
// module id = GqKD
// module chunks = 30